export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://go.emil.zip/discord";
export const GITHUB_LINK = "https://github.com/follgad";
export const TWITTER_LINK = "https://x.com/emilahlback";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
